export default __webpack_public_path__ + "static/media/live-oak.ec6c486f.jpg";